var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8904 17.4177C14.1584 17.6897 14.1584 18.1267 13.8904 18.3967C13.6224 18.6667 13.1894 18.6677 12.9214 18.3967L5.09144 10.4887C4.96277 10.3583 4.89063 10.1825 4.89063 9.99923C4.89063 9.81602 4.96277 9.64016 5.09144 9.50973L12.9214 1.60173C12.9847 1.53749 13.0601 1.48646 13.1433 1.45164C13.2265 1.41681 13.3158 1.39887 13.4059 1.39887C13.4961 1.39887 13.5854 1.41681 13.6686 1.45164C13.7517 1.48646 13.8272 1.53749 13.8904 1.60173C14.0193 1.73187 14.0916 1.9076 14.0916 2.09073C14.0916 2.27387 14.0193 2.4496 13.8904 2.57973L6.74944 9.99973L13.8904 17.4177Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronArrowLeft);
export default __webpack_public_path__ + "static/media/chevron-arrow-left.952f8b319ca9253c8ad2097f0a392260.svg";
export { ForwardRef as ReactComponent };